<template>
  <div class="flex center items-center space-x-2">
    <h3 class="text-lg leading-6 font-medium text-gray-900">
      All projects
    </h3>
    <button
      type="button"
      class="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
      @click="showCreateFrom = !showCreateFrom"
    >
      <!-- Heroicon name: solid/plus-sm -->
      <svg
        class="h-5 w-5"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        aria-hidden="true"
      >
        <path
          fill-rule="evenodd"
          d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
          clip-rule="evenodd"
        />
      </svg>
    </button>
  </div>
  <project-list
    class="mt-5"
    :projects="projects"
  />

  <div class="relative mt-5 bg-white overflow-hidden shadow rounded-lg" />
  <Modal
    :show="showCreateFrom"
    max-width="md"
    :closeable="true"
    @close="showCreateFrom = false"
  >
    <CreateProjectForm @close="showCreateFrom = false" />
  </Modal>
  <div class="relative mt-5 bg-white overflow-hidden shadow rounded-lg" />
</template>

<script>
import ProjectList from '../../ComponentsDeprecated/ProjectList.vue';
import Modal from '../../Jetstream/Modal.vue';
import CreateProjectForm from '../../Components/CreateProjectForm.vue';

export default {
  components: {
    ProjectList,
    Modal,
    CreateProjectForm,
  },
  props: {
    projects: Array,
  },
  data() {
    return {
      showCreateFrom: false,
    };
  },
};
</script>

<style lang="scss" scoped>
//
</style>
